





























# Lib autocomplete https://github.com/paliari/v-autocomplete
item = require './template_item.vue'
helpers = require '../../../helpers.coffee'
on_clickaway = require('vue-clickaway')

view_model = {
  mixins: [ on_clickaway.mixin ]

  props:
    'external_id':
      default: -> 0

    'kind':
      default: -> '0'

    'open_template_modal':
      default: -> false
    
    'user_id':
      default: -> Session.current_user.id

  data : ->
    input_text: ''
    keep_items_open: false
    show_categories: false
    categories: []
    category_selected: null
    show: false
    current_company: Session.current_company
    current_user: Session.current_user
    template: null
    templates: []
    item_template: item
    show_no_result_found_message: false
    attrs: {
      placeholder: @$t('general.placeholder.search')
    }

  methods:
    openCreateTemplateModal: ->
      return unless @open_template_modal
      @$emit 'template-selected', { id: 'create' }

      @setShowList(false)
      @show_no_result_found_message = false
      templateAttrs =
        template_kind: @kind
        template_name: @input_text
        template_category_id: @category_selected?.id

      @$emit('open-template-modal', templateAttrs)

    selectCategory: (category) ->
      @category_selected = category
      @show_categories = false
      @searchTemplates('')
      @setShowList(false)

    hideCategories: ->
      @show_categories = false
      @keep_items_open = false

    toggleCategories: ->
      @show_categories = !@show_categories

    onClickaway: ->
      @$emit 'hide'

    loadCategories: ->
      @template_category_resources.index(@loadCategoriesSuccess, @unknownError)

    loadCategoriesSuccess: (data) ->
      @categories = data.template_categories

    getLabel: (template) ->
      template?.name

    searchTemplates: (text) ->
      @input_text = text
      kind = if @kind_idx > -1 then @kind_idx else null
      filters = { kind_eq: kind, name_cont: text, user_id_eq: @user_id || @current_user.id }

      @clearTemplate() if text == ''
      limit = if text == "" then 5 else 'disabled'

      if @category_selected
        filters.template_category_id_eq = @category_selected.id
        @setShowList(true)
      @template_resources.index @searchSuccess, @unknownError, params: {q: filters, per: limit }

    searchSuccess: (resources) ->
      @templates = resources.templates
      @clearTemplate()
      @show_no_result_found_message = resources.templates.length == 0

    setShowList: (value, uid = null)->
      return @keep_items_open = value unless uid?
      @keep_items_open = value if @_uid == uid

    clearTemplate: (clear_input=false)->
      if clear_input
        autocomplete = @$children.find (c)-> c.$el.className == 'v-autocomplete'
        autocomplete.searchText = ''
        @input_text = ''
        @show_no_result_found_message = false
        @keep_items_open = false
        @template = null
        @$emit 'destroy-created-template'
      @$emit 'template-selected', { id: null }

    addTemplate: (template) ->
      @setShowList(false)
      @$emit 'hide'
      @$emit 'template-selected', template

  computed:
    show_not_result_without_modal: ->
      @show_no_result_found_message && @input_text.length > 0 && !@open_template_modal

    show_not_result_with_modal: ->
      @show_no_result_found_message && @input_text.length > 0 && @open_template_modal

    show_clear_button: ->


    kind_idx: ->
      ['email', 'phonecall', 'social', 'linkedin'].indexOf(@kind)

    id: ->
      "autocomplete_"+@external_id

    label_category: ->
      @category_selected?.name || @$t('template.label.allCategories')

  watch:
    kind: ->
      @templates = []
      @setShowList(false)
      @show_no_result_found_message = false
      @searchTemplates('')
      @clearTemplate(true)

  created: ->
    @template_resources = new TemplatesResource @current_company.id
    @template_category_resources = new TemplateCategoriesResource @current_company.id
    @loadCategories()
    @searchTemplates('', false)

    EventsBus.$on 'TemplateAutoComplete::SetShowList', @setShowList

  mounted: ->
    @attrs.placeholder = @$t('general.placeholder.search')
}
exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/autocomplete/templates.vue